<template>
    <v-form ref="aForm" lazy-validation autocomplete="nope"
            v-on="listeners" v-bind="$attrs">
        <vue-perfect-scrollbar v-if="!fullScreen" :settings="scrollSettings" :class="{'modal-scroll': modalMode}" :swicher="modalMode">
            <v-container grid-list-xl fluid :class="{'crud-modal-wrapper': modalMode, 'crud-form-wrapper': !modalMode}">
                <v-layout row wrap>
                    <v-flex xs12
                            :md6="!modalMode && !fullWidth && $slots.rightContent"
                            :md7="!modalMode && !fullWidth && !$slots.rightContent">
                        <slot></slot>
                    </v-flex>
                    <v-flex xs12 :md6="!modalMode" v-if="!fullWidth || !$slots.rightContent">
                        <slot name="rightContent"></slot>
                    </v-flex>
                </v-layout>
            </v-container>
        </vue-perfect-scrollbar>
         <v-flex xs12 v-else>
            <slot></slot>
         </v-flex>
    </v-form>
</template>

<script>
   import VuePerfectScrollbar from 'vue-perfect-scrollbar';

   export default {
      name: "crud-form",
      components: {
         VuePerfectScrollbar,
      },
      props: {
         modalMode: {
            type: Boolean,
            required: false,
            default: false
         },
         fullWidth: {
            type: Boolean,
            required: false,
            default: false
         },
         fullScreen: {
            type: Boolean,
            required: false,
            default: false
         },
         scrollSettings: {
            type: Object,
            required: false,
            default: () => {
               return {maxScrollbarLength: 160}
            }
         }
      },

      computed: {
         listeners() {
            return {
               ...this.$listeners
            }
         }
      },

      methods: {
         reset() {
            return this.$refs.aForm.reset();
         },

         validate() {
            return this.$refs.aForm.validate();
         },

         formInputs() {
            return this.$refs.aForm.inputs;
         }
      },

      mounted() {
         // console.log('modal mode', this.modalMode)
      }

   }

</script>

<style scoped>
    .modal-scroll {
        overflow-x: hidden;
        overflow-y: auto;
        min-height: 30vh;
        max-height: 75vh;
    }

    .crud-modal-wrapper {
        background-color: #f7f9fa;
        padding: 20px 20px 15px 15px;
    }
</style>


// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/layout/crudPage/crudForm.vue